define('helper-misc-msToISO',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (n) {
        n = Math.max(n, 0);

        var str = "P",
            nCs = n;

        var nY = Math.floor(nCs / 3155760000);
        nCs -= nY * 3155760000;
        var nM = Math.floor(nCs / 262980000);
        nCs -= nM * 262980000;
        var nD = Math.floor(nCs / 8640000);
        nCs -= nD * 8640000;
        var nH = Math.floor(nCs / 360000);
        nCs -= nH * 360000;
        var nMin = Math.floor(nCs / 6000);
        nCs -= nMin * 6000;
        // Now we can construct string
        if (nY > 0) str += nY + "Y";
        if (nM > 0) str += nM + "M";
        if (nD > 0) str += nD + "D";
        if (nH > 0 || nMin > 0 || nCs > 0) {
            str += "T";
            if (nH > 0) str += nH + "H";
            if (nMin > 0) str += nMin + "M";
            if (nCs > 0) str += nCs / 100 + "S";
        }

        if (str == "P") str = "PT0H0M0S";

        return str;
    };
});
